import { Checkbox as MaterialCheckbox, withStyles } from '@material-ui/core';
import { colors } from '../../../theme';

const CustomCheckbox = withStyles({
  root: {
    padding: 0,
    paddingRight: 9,
  },
  checked: {
    color: `${colors.bright_turquoise} !important`,
  },
  colorPrimary: {
    color: colors.bright_turquoise,
  },
})(MaterialCheckbox);

export default CustomCheckbox;
